// const path = require('path');
// const { Sitemap } = require('react-router-sitemap'); 
// const routerLinks = require('../../src/routes/AppRoutes'); 


import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";


export const Constent = {
  STATIC_DESCRIPTION: true,
  SEARCH_DELAY: 1000
}

export const TABKEY = {
  DETAILS_TAB: 'ipo-details',
  DOC_TAB: 'ipo-docs',
  REVIEW_TAB: 'ipo-review',
  SUBSCRIPTION_TAB: 'ipo-subscription',
  NEWS_TAB: 'ipo-news',
  GMP_TAB: 'ipo-gmp',
  ALLOTNMENT_TAB: 'ipo-allotnment',
  BASIC_ALLOTNMENT_TAB: 'basic_allotnment'
}

export function transformCompanyName(companyName) {
  return companyName
    ?.split(/\s+/) // Split by spaces
    .slice(0, 2) // Get the first two words
    .join('-') // Join with hyphen
    .toLowerCase() + '-ipo';
}

export function ManageTabname(tabName) {
  return 'ipo-' + tabName;
}

export function useIpoDetailsPageRedirection() {
  const navigate = useNavigate();
  return (SYMBOL, COMPANYNAME, DATA, TABKEY) => {
    console.log('SYMBOL 123', SYMBOL, 'COMPANYNAME', COMPANYNAME, 'DATA' ,DATA ,'TABKEY', TABKEY);

    navigate(`/ipo/${transformCompanyName(COMPANYNAME)}/${SYMBOL.toLowerCase()}/${TABKEY || 'ipo-details'}`, {
      state: { tabkey: TABKEY || DATA, data: DATA }
    });
  };
}

// const trformCompanyName = await IpoDetailsPageRedirection(data1?.symbol , data1?.company_name ,data1 ,'ipo_details')

// export function formatDate(dateStr) {
//   const date = new Date(dateStr);
//   return date?.toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'short', // This gives a 3-character month abbreviation
//     day: 'numeric',
//   });
// }


export const getCurrentYear = () => {
  return moment().year();
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date)) return "Invalid Date"; // Handle invalid dates

  const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}


export function formatIPOValue(value) {
  const valueInINR = value; // Assuming ipo_max_value is in lakhs, so multiply by 100,000

  // Format the value with currency symbol and commas
  return `₹${valueInINR?.toLocaleString('en-IN')}`;
}

export function formatCurrency(value) {
  if (value !== undefined && value !== null) {
    return `₹${value?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return '-'; // In case the value is undefined or null
}

export function formatDateWithDayNumber(apiDate) {
  const date = new Date(apiDate); // Convert the API date to a Date object

  // Get components of the date
  const month = date?.toLocaleString('en-US', { month: 'long' });
  const day = date?.getDate();
  const year = date?.getFullYear();
  const time = date?.toLocaleTimeString('en-US', { hour12: true });
  // Calculate the day number (can be done based on your logic, here it's just a placeholder)
  const dayNumber = day; // Replace with your actual logic for "Day X" if necessary
  // Return the formatted string
  return `${month} ${day}, ${year} ${time} (Day ${dayNumber})`;
}

// export const SEOTITLE = ({ title, description }) => {
//   return (
//     <Helmet>
//       <title>{title}</title>
//       <meta name="description" content={description} />
//     </Helmet>
//   );
// };

export const SEOLINK = ({ title, description, image, url, keyword }) => {
  return (
    <Helmet>
      {/* <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={window.location.href} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keyword} />
       */}
    </Helmet>
  );
};

export const SEOTITLE = ({ title, description, keyword }) => {
 

  // <SEOLINK title={title} description={description} keyword={keyword}/>
  return (
    <Helmet>
      {/* <SEOComponent title={title} description={description}/> */}

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />
      <meta name="apple-itunes-app" content="app-id=6738792695" app-argument={window.location.href} />
      
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keyword} />
     
    </Helmet>
  );
};

export const getFirstTwoWordsWithDash = (text) => {
  return text?.split(" ").slice(0, 2).join(" ") || "";
};

